export default {
  FETCH_SERVICE_INFO(state, payload) {
    state.serviceInfo = payload;
  },
};
